<template>
  <div>
    <div align="left" class="mt-5">
      <h5 class="h5 mb-3 text-primary font-weight-bold">Article</h5>
      <b-row>
        <b-col>
          <!-- <b-input-group>
            <b-input-group-text class="bg-white border-right-0" slot="prepend">
              <img src="@/assets/filter.svg" alt />
            </b-input-group-text>
            <b-dropdown
              text="Filter Data"
              variant="light"
              toggle-class="bg-white border-secondary text-primary border-left-0 pl-0"
              slot="append"
            >
              <b-dropdown-item>Action A</b-dropdown-item>
              <b-dropdown-item>Action B</b-dropdown-item>
            </b-dropdown>
          </b-input-group>-->
        </b-col>
        <b-col class="text-right">
          <div>
            <b-dropdown
              :disabled="selected.length === 0"
              :variant="selected.length === 0 ? 'primary':'warning'"
              id="dropdown-1"
              text="Action"
              class="m-md-2"
            >
              <b-dropdown-item
                :disabled="isHighlightOverLimit || isSelectedNotHighlight"
                :class="isHighlightOverLimit || isSelectedNotHighlight ? 'text-dager':'text-dager' "
                @click="submitStatus('highlight')"
                href="#"
              >Home Banner {{isSelectedNotHighlight ? "Not Valid"  : isHighlightOverLimit ? "Over Limit":""}}</b-dropdown-item>
              <b-dropdown-item @click="submitStatus('publish')" href="#">Publish</b-dropdown-item>
              <b-dropdown-item @click="submitStatus('my_reward')" href="#">My Reward</b-dropdown-item>
              <b-dropdown-item @click="submitStatus('archive')" href="#">Archive</b-dropdown-item>
            </b-dropdown>
            <router-link :to="{name: 'createArticle'}">
              <b-button variant="primary">
                <img src="@/assets/create-new.svg" alt class="mr-2" /> Create New
              </b-button>
            </router-link>
          </div>
          <!-- <b-button variant="primary" @click="submitStatus()">
            <img src="@/assets/create-new.svg" alt class="mr-2" /> Send ID
          </b-button>-->
        </b-col>
      </b-row>
    </div>
    <br />
    <div class="text-left">
      <b-row>
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1"></b-col>
        <b-col md="3" class="my-1" align="right"></b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <section v-if="errored">
        <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
      </section>
      <!-- Main table element -->
      <b-table
        v-else
        show-empty
        ref="selectableTable"
        selectable
        :select-mode="selectMode"
        @row-selected="onRowSelected"
        striped
        responsive
        hover
        :items="getInfo"
        :per-page="perPage"
        :current-page="currentPage"
        :fields="fields"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
        :style="loading ? 'pointer-events:none;' : ''"
        filter-debounce="500"
        empty-text="loading"
      >
        <template v-slot:head(selected)="data" class="fas fa-check">
          <p class="fas fa-check">{{data.label}}</p>
        </template>
        <template v-slot:thead-top="data">
          <b-tr>
            <b-th colspan="2"></b-th>
            <b-th colspan="2" class="text-center p-2">Publish Date</b-th>
            <b-th colspan="8"></b-th>
          </b-tr>
        </template>
        <!-- NOTE, SPINNER LOADING FOR INITIAL LOAD -->
        <div v-if="!isDataReady && loading" slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:head(selected)="data">
          <span class="text-info">
            <b-form-checkbox
              v-model="allSelected"
              :indeterminate="indeterminate"
              aria-describedby="items"
              aria-controls="items"
              @change="toggleAll"
            ></b-form-checkbox>
          </span>
        </template>
        <template v-slot:cell(selected)="{ rowSelected, item, index }">
          <template v-if="rowSelected">
            <span aria-hidden="true">
              <b-form-checkbox
                id="checkbox-1"
                v-model="selected_field_true"
                name="checkbox-1"
                value="true"
                class="pointer-off"
                unchecked-value="false"
              ></b-form-checkbox>
            </span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">
              <b-form-checkbox
                id="checkbox-1"
                v-model="selected_field_false"
                name="checkbox-1"
                value="true"
                class="pointer-off"
                unchecked-value="false"
              ></b-form-checkbox>
            </span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>
        <template v-slot:cell(category)="row">
          <p
            class="font-weight-bolder text-primary"
            v-if="row.value == 'antarkankebaikan'"
          >#AntarkanKebaikan</p>
          <p class="font-weight-bolder text-primary" v-else-if="row.value == 'paxelmarket'">
            Paxel Market
          </p>
          <p class="font-weight-bolder text-primary" v-else-if="row.value == 'pejuangonline'">
            #PejuangOnline
          </p>
          <p class="font-weight-bolder text-primary text-capitalize" v-else>{{row.value}}</p>
        </template>
        <template v-slot:cell(status)="row">
          <p class="text-success" v-if="row.value == 'publish'">Publish</p>
          <p class="text-primary" v-else-if="row.value == 'highlight'">Home Banner</p>
          <p class="text-warning" v-else-if="row.value == 'archive'">Archive</p>
          <p class="text-info" v-else-if="row.value == 'my_reward'">My Reward</p>
        </template>
        <template v-slot:cell(created_at)="{ value, item }">
          <p class="mb-0">{{item.created_at_date_only}}</p>by
          <label class="font-weight-bold">{{item.created_by_username}}</label>
        </template>
        <template v-slot:cell(updated_at)="{ value, item }">
          <div v-if="item.updated_at_date_only == ''">-</div>
          <div v-else>
            <p class="mb-0">{{item.updated_at_date_only}}</p>by
            <label class="font-weight-bold">{{item.updated_by_username}}</label>
          </div>
        </template>
        <template v-slot:cell(order_for_category)="{ value, item }">
          <div>{{value}}&nbsp;</div>
          <br>
          <b-link
            :class="{'order-link':item.order_for_category === 1}"
            @click="orderArticle({id:item.id,change:'up'})"
            class="text-primary"
            v-b-tooltip.hover
            title="Up Order"
          >
            <i class="fas fa-arrow-up mr-2"></i>
          </b-link>
          <b-link
            class="text-primary"
            :class="{'order-link':item.is_last_order}"
            @click="orderArticle({id:item.id,change:'down'})"
            v-b-tooltip.hover
            title="Down Order"
          >
            <i class="fas fa-arrow-down"></i>
          </b-link>
        </template>
        <template v-slot:cell(order_for_highlight)="{ value, item }">
          <div>{{value === 0 ? "-":value}}&nbsp;</div>
          <br>
          <div v-if="item.status === 'highlight'">
          <b-link
            :class="{'order-link':item.order_for_highlight === 1}"
            @click="orderArticleHighlight({id:item.id,change:'up'})"
            class="text-primary"
            v-b-tooltip.hover
            title="Up Order"
          >
            <i class="fas fa-arrow-up mr-2"></i>
          </b-link>
          <b-link
            class="text-primary"
            :class="{'order-link':item.is_last_order}"
            @click="orderArticleHighlight({id:item.id,change:'down'})"
            v-b-tooltip.hover
            title="Down Order"
          >
            <i class="fas fa-arrow-down"></i>
          </b-link>
          </div>
        </template>
        <template v-slot:cell(title.id)="row">
          <div>{{row.value === "" ? "Empty":row.value.substring(0,25)}}&nbsp;</div>
        </template>
        <template v-slot:cell(period.start_date)="{value, item}">
          <div>{{item.publish_date_start === "" ? "Empty":item.publish_date_start.substring(0,10)}}&nbsp;</div>
        </template>
        <template v-slot:cell(period.end_date)="{value, item}">
          <div>&nbsp;{{item.publish_date_end === "" ? "Empty":item.publish_date_end.substring(0,10)}}</div>
        </template>
        <template v-slot:cell(image)="row">
          <b-img :src="row.value" width="70px" rounded alt="Image"></b-img>
        </template>
        <template v-slot:cell(action)="{ value, item }">
          <router-link
            v-b-tooltip.hover
            title="Edit"
            :to="{name: 'editArticle', params: {id: item.id}}"
            class="text-dark"
          >
            <img class="mr-2" src="@/assets/ic-edit.svg" alt />
          </router-link>
          <b-link
            v-b-tooltip.hover
            title="View Detail"
            @click="modalShow = !modalShow"
            class="text-dark"
          >
            <img class="mr-2" @click="getDetail(item.id)" src="@/assets/ic-view-detail.svg" alt />
          </b-link>
          <b-link v-b-tooltip.hover title="Delete" class="text-dark" @click="del(item.id)">
            <img src="@/assets/rectangle.svg" class="mr-2" alt />
          </b-link>
          <b-link v-b-tooltip.hover title="Copy Link" class="text-primary" @click="copy(item.my_reward_url_id,item.my_reward_url_en)">
            <i class="fas fa-copy fa-lg mr-2"></i> 
          </b-link>
        </template>
      </b-table>

      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">Total entries {{totalRows}}</b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
    <b-modal v-model="modalShow" size="xl" ok-only hide-header>
      <b-row>
        <b-col>
          <h5 class="font-weight-bold">Preview</h5>
        </b-col>
        <b-col class="text-right">
          <i class="fas fa-times" @click="modalShow = !modalShow" style="cursor: pointer;"></i>
        </b-col>
      </b-row>
      <br />
      <h6 class="text-capitalize font-weight-bold">{{detail.category}}</h6>
      <b-row>
        <b-col md="4">
          <img v-if="detail.image" width="100%" :src="detail.image" />
        </b-col>
        <b-col>
          <b-row>
            <b-col md="12" class="font-weight-bold">Title:</b-col>
            <b-col md="4" class="font-weight-bold">In Bahasa</b-col>
            <b-col md="8">{{modalShow ? detail.title.id:''}}</b-col>
            <b-col md="4" class="font-weight-bold">In English</b-col>
            <b-col md="8">{{modalShow ? detail.title.en:''}}</b-col>
            <br />
            <b-col md="12" class="font-weight-bold">Content:</b-col>
            <b-col md="4" class="font-weight-bold">In Bahasa</b-col>
            <b-col md="8" v-html="modalShow ? detail.content.id:''"></b-col>
            <b-col md="4" class="font-weight-bold">In English</b-col>
            <b-col md="8" v-html="modalShow ? detail.content.en:''"></b-col>
            <br />
            <br />
            <b-col
              md="12"
              v-show="detail.category == 'promo' && detail.promo_product_roles.is_promo_product_roles_yes"
            >
              <b-row>
                <b-col md="12" class="font-weight-bold">Promo Product Rules:</b-col>
                <b-col md="4" class="font-weight-bold">Promo Code</b-col>
                <b-col
                  md="8"
                >{{modalShow && detail.category == 'promo' ? detail.promo_product_roles.promo_code:''}}</b-col>
                <br />
                <br />
                <b-col md="6" class="font-weight-bold">Product Detail:</b-col>
                <b-col md="6" class="font-weight-bold">
                  <b-link
                    class="text-primary"
                    @click="product_detail = !product_detail"
                  >{{product_detail ? 'Minimize':'See Detail'}}</b-link>
                </b-col>
                <b-col md="12" v-show="product_detail">
                  <b-row>
                    <b-col md="4" class="font-weight-bold">Product Type</b-col>
                    <b-col
                      class="text-capitalize"
                      md="8"
                    >{{modalShow && detail.category == 'promo' ? detail.promo_product_roles.product_master.type.replace("_", " "):''}}</b-col>
                    <b-col md="4" class="font-weight-bold">Product Name</b-col>
                    <b-col
                      md="8"
                    >{{modalShow && detail.category == 'promo' ? detail.promo_product_roles.product_master.name:''}}</b-col>
                    <b-col md="4" class="font-weight-bold">Product Category</b-col>
                    <b-col
                      md="8"
                    >{{modalShow && detail.category == 'promo' ? detail.promo_product_roles.product_master.category.name.id:''}}</b-col>
                    <b-col md="4" class="font-weight-bold">Product Dimension</b-col>
                    <b-col
                      md="8"
                    >{{modalShow && detail.category == 'promo' ? detail.promo_product_roles.product_master.dimension_height:''}}x{{modalShow && detail.category == 'promo'? detail.promo_product_roles.product_master.dimension_width:''}}x{{modalShow && detail.category == 'promo' ? detail.promo_product_roles.product_master.dimension_length:''}}</b-col>
                    <b-col md="4" class="font-weight-bold">Item(s) fit to:</b-col>
                    <b-col md="8">
                      <b-row>
                        <b-col class="text-left">Small (S)</b-col>
                        <b-col>
                          <b-form-input
                            size="sm"
                            type="number"
                            readonly="readonly"
                            :value="modalShow && detail.promo_product_roles != null && detail.promo_product_roles.is_promo_product_roles_yes  && detail.category == 'promo' ? detail.promo_product_roles.product_master.fit_to.small_minimum:''"
                            placeholder="Min"
                          ></b-form-input>
                        </b-col>
                        <p class="pt-2 mb-0">to</p>
                        <b-col>
                          <b-form-input
                            size="sm"
                            type="number"
                            readonly="readonly"
                            :value="modalShow && detail.promo_product_roles != null && detail.promo_product_roles.is_promo_product_roles_yes && detail.category == 'promo' ? detail.promo_product_roles.product_master.fit_to.small_maximum:''"
                            placeholder="Max"
                          ></b-form-input>
                        </b-col>
                        <p class="pt-2 mb-0">Item</p>
                      </b-row>
                      <b-row class="mt-3">
                        <b-col class="text-left">Medium (M)</b-col>
                        <b-col>
                          <b-form-input
                            size="sm"
                            type="number"
                            readonly="readonly"
                            :value="modalShow && detail.promo_product_roles != null && detail.promo_product_roles.is_promo_product_roles_yes && detail.category == 'promo' ? detail.promo_product_roles.product_master.fit_to.medium_minimum:''"
                            placeholder="Min"
                          ></b-form-input>
                        </b-col>
                        <p class="pt-2 mb-0">to</p>
                        <b-col>
                          <b-form-input
                            size="sm"
                            type="number"
                            readonly="readonly"
                            :value="modalShow && detail.promo_product_roles != null && detail.promo_product_roles.is_promo_product_roles_yes && detail.category == 'promo' ? detail.promo_product_roles.product_master.fit_to.medium_maximum:''"
                            placeholder="Max"
                          ></b-form-input>
                        </b-col>
                        <p class="pt-2 mb-0">Item</p>
                      </b-row>
                      <b-row class="mt-3">
                        <b-col class="text-left">Large (L)</b-col>
                        <b-col>
                          <b-form-input
                            size="sm"
                            type="number"
                            readonly="readonly"
                            :value="modalShow && detail.promo_product_roles != null && detail.promo_product_roles.is_promo_product_roles_yes && detail.category == 'promo' ? detail.promo_product_roles.product_master.fit_to.large_minimum:''"
                            placeholder="Min"
                          ></b-form-input>
                        </b-col>
                        <p class="pt-2 mb-0">to</p>
                        <b-col>
                          <b-form-input
                            size="sm"
                            type="number"
                            readonly="readonly"
                            :value="modalShow && detail.promo_product_roles != null && detail.promo_product_roles.is_promo_product_roles_yes && detail.category == 'promo' ? detail.promo_product_roles.product_master.fit_to.large_maximum:''"
                            placeholder="Max"
                          ></b-form-input>
                        </b-col>
                        <p class="pt-2 mb-0">Item</p>
                      </b-row>
                      <b-row class="mt-3">
                        <b-col class="text-left">Custom (C)</b-col>
                        <b-col>
                          <b-form-input
                            size="sm"
                            type="number"
                            readonly="readonly"
                            :value="modalShow && detail.promo_product_roles != null && detail.promo_product_roles.is_promo_product_roles_yes && detail.category == 'promo' ? detail.promo_product_roles.product_master.fit_to.custom_minimum:''"
                            placeholder="Min"
                          ></b-form-input>
                        </b-col>
                        <p class="pt-2 mb-0">to</p>
                        <b-col>
                          <b-form-input
                            size="sm"
                            type="number"
                            readonly="readonly"
                            :value="modalShow && detail.promo_product_roles != null && detail.promo_product_roles.is_promo_product_roles_yes && detail.category == 'promo' ? detail.promo_product_roles.product_master.fit_to.custom_maximum:''"
                            placeholder="Max"
                          ></b-form-input>
                        </b-col>
                        <p class="pt-2 mb-0">Item</p>
                      </b-row>
                    </b-col>
                    <b-col md="4" class="font-weight-bold">Product Normal Price</b-col>
                    <b-col
                      md="8"
                    >{{modalShow && detail.category == 'promo' ? detail.promo_product_roles.product_master.normal_price:''}}</b-col>
                    <b-col md="4" class="font-weight-bold">Product Status:</b-col>
                    <b-col md="8">
                      <label
                        v-for="data in modalShow && detail.category == 'promo' ? detail.promo_product_roles.product_master.product_status:''"
                        :key="data"
                        class="text-capitalize"
                      >{{data.Name+', '}}</label>
                    </b-col>
                    <b-col md="4" class="font-weight-bold">Quota per day per user:</b-col>
                    <b-col
                      md="8"
                    >{{modalShow && detail.category == 'promo' ? detail.promo_product_roles.product_master.quota_per_day:''}}</b-col>
                    <b-col md="4" class="font-weight-bold">Sender Name / Contact:</b-col>
                    <b-col
                      md="8"
                      class="mb-3"
                    >{{modalShow && detail.category == 'promo' ? detail.promo_product_roles.product_master.sender_name:''}}/{{modalShow && detail.category == 'promo' ? detail.promo_product_roles.product_master.sender_phone_number:''}}</b-col>
                    <b-col
                      md="4"
                      class="font-weight-bold"
                      v-if="modalShow && detail.category == 'promo' && detail.promo_product_roles.product_master.type == 'pre_order'"
                    >Preferred pickup slot / day:</b-col>
                    <b-col
                      md="8"
                      v-if="modalShow && detail.category == 'promo' && detail.promo_product_roles.product_master.type == 'pre_order'"
                    >
                      {{modalShow && detail.category == 'promo' && detail.promo_product_roles.product_master.type == 'pre_order' ? detail.promo_product_roles.product_master.pre_order.preferred_pickup.display_name:''}}&nbsp; /
                      <label
                        v-for="data in modalShow && detail.category == 'promo' && detail.promo_product_roles.product_master.type == 'pre_order' ? detail.promo_product_roles.product_master.pre_order.preferred_days:''"
                        :key="data"
                      >
                        <label
                          class="mb-0 text-capitalize"
                          v-show="data.is_selected"
                        >{{data.name + ','}}</label>
                      </label>
                    </b-col>
                    <b-col
                      v-if="modalShow && detail.category == 'promo' && detail.promo_product_roles.product_master.type == 'pre_order'"
                      md="4"
                      class="font-weight-bold"
                    >Stock:</b-col>
                    <b-col
                      v-if="modalShow && detail.category == 'promo' && detail.promo_product_roles.product_master.type == 'pre_order'"
                      md="8"
                      class="mb-3"
                    >{{modalShow && detail.category == 'promo' && detail.promo_product_roles.product_master.type == 'pre_order' ? detail.promo_product_roles.product_master.pre_order.stock:''}}</b-col>
                    <b-col
                      v-if="modalShow && detail.category == 'promo' && detail.promo_product_roles.product_master.type == 'stock_point'"
                      md="4"
                      class="font-weight-bold"
                    >PH / Stock:</b-col>
                    <b-col
                      class="mb-4"
                      v-if="modalShow && detail.category == 'promo' && detail.promo_product_roles.product_master.type == 'stock_point'"
                      md="8"
                    >
                      <b-row
                        v-for="(input , k) in modalShow && detail.category == 'promo' && detail.promo_product_roles.product_master.type == 'stock_point' ? detail.promo_product_roles.product_master.stock_point:''"
                        :key="k"
                      >
                        <b-col md="4">{{'PH ' + input.warehouse.name}}</b-col>
                        <b-col md="1">/</b-col>
                        <b-col class="text-left">{{input.stock}} pcs</b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
                <br />
                <br />
                <b-col md="4" class="font-weight-bold">Discount Type</b-col>
                <b-col
                  md="8"
                >{{modalShow && detail.category == 'promo' ? detail.promo_product_roles.discount_type.name:''}}</b-col>
                <b-col md="4" class="font-weight-bold">Discount Value</b-col>
                <b-col
                  md="8"
                >{{modalShow && detail.category == 'promo' ? detail.promo_product_roles.discount_value:''}}</b-col>
                <b-col md="4" class="font-weight-bold">Quantity Product/promo</b-col>
                <b-col
                  md="8"
                >{{modalShow && detail.category == 'promo' ? detail.promo_product_roles.qty_product_per_promo:''}}</b-col>
                <b-col md="4" class="font-weight-bold">Quota Promo/user</b-col>
                <b-col
                  md="8"
                >{{modalShow && detail.category == 'promo' ? detail.promo_product_roles.quota_promo_per_user:''}}</b-col>
              </b-row>
            </b-col>
            <b-col
              md="12"
              v-show="detail.category == 'antarkankebaikan' && detail.antarkan_kebaikan_roles.is_antarkankebaikan_roles_yes"
            >
              <b-row>
                <b-col md="12" class="font-weight-bold">Antarkankebaikan Rules:</b-col>
                <b-col md="4" class="font-weight-bold">Promo Code:</b-col>
                <b-col
                  md="8"
                >{{modalShow && detail.category == 'antarkankebaikan' ? detail.antarkan_kebaikan_roles.promo_code:''}}</b-col>
                <b-col md="4" class="font-weight-bold">Name:</b-col>
                <b-col
                  md="8"
                >{{modalShow && detail.category == 'antarkankebaikan' ? detail.antarkan_kebaikan_roles.name:''}}</b-col>
                <b-col md="4" class="font-weight-bold">Contact:</b-col>
                <b-col
                  md="8"
                >{{modalShow && detail.category == 'antarkankebaikan' ? detail.antarkan_kebaikan_roles.contact:''}}</b-col>
                <b-col md="4" class="font-weight-bold">Destination:</b-col>
                <b-col
                  md="8"
                >{{modalShow && detail.category == 'antarkankebaikan' ? detail.antarkan_kebaikan_roles.destination:''}}</b-col>
                <b-col md="4" class="font-weight-bold">Package Size:</b-col>
                <b-col
                  md="8"
                >{{modalShow && detail.category == 'antarkankebaikan' ? detail.antarkan_kebaikan_roles.package_size.name:''}}</b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      mainProps: {
        blank: true,
        blankColor: "#777",
        width: 50,
        height: 50,
        class: "m1"
      },
      modalShow: false,
      loading: false,
      isDataReady: false,
      errored: false,
      selected_field_true: true,
      selected_field_false: false,
      items: [],
      selectMode: "multi",
      selected: [],
      allSelected: false,
      indeterminate: false,
      fields: [
        {
          key: "selected",
          class: "text-center w-5"
        },
        {
          key: "created_at",
          label: "Created",
          sortable: true,
          class: "text-left"
        },
        {
          key: "period.start_date",
          label: "Start",
          sortable: true,
          class: "text-center"
        },
        {
          key: "period.end_date",
          label: "End",
          sortable: true,
          class: "text-center"
        },
        {
          key: "category",
          label: "Type",
          sortable: true,
          class: "text-left"
        },
        {
          key: "title.id",
          label: "Title",
          sortable: true,
          class: "text-left text-nowrap",
          thStyle: {
            width: "80px"
          }
        },
        {
          key: "image",
          label: "Image",
          class: "text-center"
        },
        {
          key: "updated_at",
          label: "Updated",
          sortable: true,
          class: "text-left"
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          class: "text-center"
        },
        {
          key: "order_for_highlight",
          label: "Order Number Home Banner",
          sortable: true,
          class: "text-center"
        },
        {
          key: "order_for_category",
          label: "Order Number Type",
          sortable: true,
          class: "text-center"
        },
        { key: "action", label: "Action", class: "text-center w-10" }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      detail: [],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: "",
      customerShow: false,
      product_detail: false,
      counthighlight: {  total: 0 },
      infoModal: {
        id: "info-modal",
        title: "",
        content: ""
      }
    };
  },
  computed: {
    isHighlightOverLimit() {
      return (this.counthighlight.total + this.selected.length) > 15;
    },
    isSelectedNotHighlight() {
      return this.selected.some(x => x.category !== "highlights")
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    },
    rows() {
      return this.items.length;
    }
  },
  beforeCreate() {
    this.$store.dispatch("ArticleModule/getCountHighlight", null, {
      root: true
    });
  },
  created() {
    this.$store.watch(
      state => state.ArticleModule.counthighlight,
      (newValue, oldValue) => {
        this.counthighlight = newValue;
      }
    );
  },
  mounted() {
    this.totalRows = this.items.length;
  },
  methods: {
    getDetail(payload) {
      this.$store
        .dispatch("ArticleModule/getArticle", payload)
        .then(response => {
          this.detail = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    async getInfo(ctx) {
      this.loading = true;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", ctx.sortDesc);
      formData.append("status", "publish");
      formData.append("status", "archive");
      formData.append("status", "highlight");
      formData.append("status", "my_reward");
      try {
        const response = await this.$store.dispatch("ArticleModule/getArticles2", formData);
        this.totalRows = response.data.data.total_record;
        if(!this.isDataReady) {
          this.isDataReady = true;
        }
        return response.data.data.results || [];
      } catch (err) {
        console.log({err})
        return [];
      } finally {
        this.loading = false;
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      // this.totalRows = filteredItems.length;
      // this.currentPage = 1;
    },
    del(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("ArticleModule/delArticle", id);
          this.$refs.selectableTable.refresh();
          this.$swal("Deleted!", "Your file has been deleted.", "success");
        }
      });
    },
    onRowSelected(items) {
      this.selected = items;
    },
    submitStatus(status) {
      this.$swal({
        title: "Are you sure?",
        text: `You will ${status} this On Article!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, change it!"
      }).then(result => {
        if (result.value) {
          const formData = new FormData();
          $.each(this.selected, (key, value) => {
            formData.append("articleid", value.id);
            formData.append("status", status);
          });
          $.each(formData.getAll("articleid"), (key, value) => {
            console.log(value);
          });

          this.loading = true;

          this.$store
            .dispatch("ArticleModule/updateStatusArticles", formData)
            .then(response => {
              this.loading = false;
              this.$refs.selectableTable.refresh();
              this.$store.dispatch("ArticleModule/getCountHighlight", null, {
                root: true
              });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1000
              });
              console.log(response);
            })
            .catch(error => {
              this.loading = false;
              this.serverError = error.response;
              console.log(error);
            });
        }
      });

      // console.log(list);
    },
    toggleAll(checked) {
      this.selected = checked
        ? this.$refs.selectableTable.selectAllRows()
        : this.$refs.selectableTable.clearSelected();
    },
    copy(data_id,data_en) {
      var link_id = data_id;
      var link_en = data_en;
      var dummy = document.createElement("input");
      document.body.appendChild(dummy);
        this.$swal({
          title: 'Copy Link ID / EN ?',
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#3085d6",
          cancelButtonText: 'Link EN',
          confirmButtonText: "Link ID"
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          console.log(result)
          if (result.value) {
            dummy.value = link_id;
            dummy.select();
            document.execCommand("copy");
            document.body.removeChild(dummy);
            this.$swal({
              title: "Link ID Copied",
              type: "success",
              showConfirmButton: false,
              timer: 1000,
            });
          } else if (result.dismiss == 'cancel') {
            dummy.value = link_en;
            dummy.select();
            document.execCommand("copy");
            document.body.removeChild(dummy);
            this.$swal({
              title: "Link EN Copied",
              type: "success",
              showConfirmButton: false,
              timer: 1000,
            });
          }
        })
      
    },
    orderArticle(order) {
      this.loading = true;
      const orderData = {
        change_type: order.change
      };
      this.$store
        .dispatch("ArticleModule/orderArticle", {
          id: order.id,
          orderData
        })
        .then(response => {
          this.$refs.selectableTable.refresh();
          this.$swal({
            type: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            timer: 1500
          });
          console.log(response);
        })
        .catch(error => {
          this.loading = false;
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500
          });
          console.log(error);
        });
    },
    orderArticleHighlight(order) {
      this.loading = true;
      const orderData = {
        change_type: order.change
      };
      this.$store
        .dispatch("ArticleModule/orderArticleHighlight", {
          id: order.id,
          orderData
        })
        .then(response => {
          this.$refs.selectableTable.refresh();
          this.$swal({
            type: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            timer: 1500
          });
          console.log(response);
        })
        .catch(error => {
          this.loading = false;
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500
          });
          console.log(error);
        });
    },
  },
  watch: {
    selected(newVal, oldVal) {
      if (newVal.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (newVal.length === this.items.length) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
    }
  }
};
</script>

<style scoped>
.pointer-off {
  pointer-events: none;
}
.title {
  width: 120px;
}
</style>
